import React from 'react'
import cx from 'classnames'

import Logo from 'components/ui/Logo/Logo'
import Box from 'components/_new/layout/Box/Box'
import AppStoreButton from 'components/ui/AppStoreButton/AppStoreButton'
import WidthContainer from 'components/_new/layout/widthContainer/WidthContainer/WidthContainer'
import FooterCollectEmailForm from 'components/layout/Footer/FooterCollectEmailForm/FooterCollectEmailForm'

import FooterLinks from './FooterLinks/FooterLinks'
import FooterSocials from './FooterSocials/FooterSocials'
import FooterCopyright from './FooterCopyright/FooterCopyright'

import s from './ExceptMobile.scss'


const FooterExceptMobile = () => (
  <div className={s.footer}>
    <WidthContainer className={s.container}>
      <div className={s.column}>
        <Logo className={s.logo} light />
        <Box mt="16">
          <AppStoreButton />
        </Box>
      </div>
      <div className={s.column}>
        <FooterCollectEmailForm isHumble />
      </div>
      <div className={cx(s.column, s.withPaddingLeft)}>
        <FooterLinks />
      </div>
      <div className={s.column}>
        <FooterCopyright />
      </div>
      <div className={s.column}>
        <FooterSocials />
      </div>
    </WidthContainer>
  </div>
)


export default FooterExceptMobile
